










































import {Component, Provide, Vue, Prop, Watch} from 'vue-property-decorator';
import {Action, State} from 'vuex-class';
import axios from 'axios';
import {baseUrlAPI} from '@/globals';
import ErrorNotifier from '@/domain/util/notifications/ErrorNotifier';
import ComplaintState from '@/store/modules/complaint/types';

@Component({ })
export default class ImagesGallery extends Vue {

    @State('complaint') public complaintState: ComplaintState;

    @Provide() public buttonText = 'Добавить файлы';

    @Provide() public isDragover = false;

    public selectFiles() {
        // @ts-ignore
        this.$el.querySelector('input.files').click();
    }

    public uploadFiles() {

        this.buttonText = 'Загрузка ...';

        // @ts-ignore
        const files = this.$el.querySelector('input.files').files;

        const data = new FormData();
        for (const file of files) {
            data.append('files[]', file, file.name);
        }

        axios.post(`${baseUrlAPI}complaint/upload`, data).then((response) => {
            this.complaintState.complaint.attachments = this.complaintState.complaint.attachments.concat(response.data);
            this.buttonText = 'Добавить файлы';
        }).catch((error) => {
            ErrorNotifier.notify();
            this.buttonText = 'Добавить файлы';
        });

    }

    public dropFiles(e) {

        const droppedFiles = e.dataTransfer.files;
        if (!droppedFiles) {
            return;
        }

        const data = new FormData();
        for (const file of droppedFiles) {
            data.append('files[]', file, file.name);
        }

        axios.post(`${baseUrlAPI}complaint/upload`, data).then((response) => {
            this.complaintState.complaint.attachments = this.complaintState.complaint.attachments.concat(response.data);
            this.buttonText = 'Добавить файлы';
        }).catch((error) => {
            ErrorNotifier.notify();
            this.buttonText = 'Добавить файлы';
        });

        this.isDragover = false;
    }

    public dragoverFiles() {
        this.isDragover = true;
    }

    public dragleaveFiles() {
        this.isDragover = false;
    }

    public deleteFile(i) {
        const file = Object.assign({}, this.complaintState.complaint.attachments[i], { isDeleted: true });
        this.complaintState.complaint.attachments.splice(i, 1, file);
    }

    public restoreFile(i) {
        const file = Object.assign({}, this.complaintState.complaint.attachments[i], { isDeleted: false });
        this.complaintState.complaint.attachments.splice(i, 1, file);
    }

}
